import { useAppsStore } from "@/pinia/appsStore";
import { computed } from "vue";
import { ENGAGEMENT_SUBCATEGORIES } from "@/utils/constants/EngagementCategoryConstants";

export const useEngagementCategories = () => {
  const appsStore = useAppsStore();

  const engagementCategoriesEnabled = computed(() => true);

  const retentionOnlyMode = computed(() => appsStore.app?.flags?.retention_only_mode || false);

  const engagementCategories = computed(() => {
    const categories = appsStore.app?.engagement_categories || [];
    return [{ value: null, label: "None" }, ...categories];
  });

  const engagementCategoriesWithRestrictions = computed(() => {
    const categories = appsStore.app?.engagement_categories || [];
    if (!retentionOnlyMode.value) return categories;
    return categories.map(cat => ({
      ...cat,
      disabled: cat.value !== "retention",
      disabledMessage: cat.value !== "retention" ? "Upgrade to Full Engage to utilize" : undefined,
    }));
  });

  // Backend payload wins once it ships; bundled constants cover deploys that race
  // the engagement_subcategories rollout in the apps payload
  const retentionSubcategories = computed(() => {
    const subcategories = appsStore.app?.engagement_subcategories;
    if (!Array.isArray(subcategories)) return Object.values(ENGAGEMENT_SUBCATEGORIES);
    return subcategories.filter(subcategory => subcategory.category === "retention");
  });

  return {
    engagementCategoriesEnabled,
    retentionOnlyMode,
    engagementCategories,
    engagementCategoriesWithRestrictions,
    retentionSubcategories,
  };
};
